const Vue = require('vue');
const $ = require('jquery');

require('./polyfills/array.forEach');
require('./polyfills/element.classList');

require('./init.contact-icons-home');
require('./init.scroll-effects');
require('./init.tiny-slider');
require('./init.cookie-settings');

import OverviewSlider from './components/overview-slider.vue';

Vue.component('overview-slider', OverviewSlider);

const app = new Vue({
  el: '#website',

  data() {
    return {
      mobileMenu: false
    };
  },

  watch: {
    mobileMenu(newValue, oldValue) {
      if (newValue === true) {
        document.getElementById('website').classList.add('--mobile-menu');
      } else {
        document.getElementById('website').classList.remove('--mobile-menu');
      }
    }
  },

  mounted() {
    this.addMobileMenuEvents();
  },

  methods: {
    addMobileMenuEvents() {
      const elements = document.querySelectorAll('.mobile-menu .menu-item-has-children');

      if (elements.length > 0) {
        elements.forEach((element) => {
          element.addEventListener('click', (e) => {
            const target = e.target;
            const submenu = target.querySelector('.sub-menu');

            if (submenu !== null && !target.classList.contains('open')) {
              target.classList.add('open');

              // jQuery meuk
              $(submenu).slideToggle(150);
            } else {
              target.classList.remove('open');

              // jQuery meuk
              $(submenu).slideToggle(75);

            }
          });
        });
      }
    }
  }
});
